import { PayloadAction } from '@reduxjs/toolkit'
import { TProductFilters, TSelectFilterOption } from '../../../models'

const setCategories = (
  state: TProductFilters[],
  action: PayloadAction<{
    id: number
    categories?: TSelectFilterOption[]
  }>
) => {
  const selectedFilters = state.find((item) => item.id === action.payload.id)

  if (!selectedFilters) {
    const newState = {
      id: action.payload.id,
      filters: {
        categories: action.payload.categories,
      },
    }
    state.push(newState)
  } else {
    selectedFilters.filters.categories = action.payload.categories || undefined
  }
}

export default setCategories
